import { render, staticRenderFns } from "./InterfaceDefinitionEditor.vue?vue&type=template&id=2f74a8a4&"
import script from "./InterfaceDefinitionEditor.vue?vue&type=script&lang=ts&"
export * from "./InterfaceDefinitionEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanelContent})
